import { getPostsForAuthor } from '@space-cow-media/wp-components'
import { PostType } from '@space-cow-media/wp-components'
import { GetServerSidePropsContext } from 'next'

import Container from '@/components/Container/Container'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import ArticleSearch from '@/components/Wordpress/ArticleSearch/ArticleSearch'
import ArticleTypePage from '@/components/Wordpress/ArticleTypePage/ArticleTypePage'
import { ARTICLES_CACHE_CONTROL } from '@/utils/constants'

export type Props = {
  author: string
  authorName: string
  pageCount: number
  pageNum: number
  posts: PostType[]
}

const ArticlesAuthorSubPage = ({ author, authorName, pageCount, pageNum, posts }: Props) => (
  <Main>
    <Container>
      <div className='mx-3'>
        <SimpleHeader className='d-flex gap-3 mb-3'>
          {authorName}
          <ArticleSearch />
        </SimpleHeader>
        <ArticleTypePage pageCount={pageCount} pageNum={pageNum} path={`author/${author}`} posts={posts} />
      </div>
    </Container>
  </Main>
)

export const getServerSideProps = async ({ params, res }: GetServerSidePropsContext) => {
  const author = params?.author as string
  let page = params?.page as string | undefined

  if (page === '1') {
    return {
      redirect: {
        destination: `/articles/author/${author}`,
        permanent: true,
      },
    }
  } else if (page === undefined) {
    page = '1'
  }

  res.setHeader('Cache-Control', ARTICLES_CACHE_CONTROL)

  const pageNum = parseInt(page as string, 10)
  const { pageCount, posts } = await getPostsForAuthor({ author, categoryId: 4, pageNum })

  return {
    props: {
      author,
      authorName: posts.length ? posts[0].author.name : '',
      pageCount,
      pageNum,
      posts,
    },
  }
}

export default ArticlesAuthorSubPage
